/* eslint-disable @typescript-eslint/no-explicit-any */
// Based on https://github.com/drizzle-team/drizzle-orm/blob/main/drizzle-zod/src/index.ts
//                                Apache License
//                          Version 2.0, January 2004
//                       http://www.apache.org/licenses/

//  TERMS AND CONDITIONS FOR USE, REPRODUCTION, AND DISTRIBUTION

//  1. Definitions.

//     "License" shall mean the terms and conditions for use, reproduction,
//     and distribution as defined by Sections 1 through 9 of this document.

//     "Licensor" shall mean the copyright owner or entity authorized by
//     the copyright owner that is granting the License.

//     "Legal Entity" shall mean the union of the acting entity and all
//     other entities that control, are controlled by, or are under common
//     control with that entity. For the purposes of this definition,
//     "control" means (i) the power, direct or indirect, to cause the
//     direction or management of such entity, whether by contract or
//     otherwise, or (ii) ownership of fifty percent (50%) or more of the
//     outstanding shares, or (iii) beneficial ownership of such entity.

//     "You" (or "Your") shall mean an individual or Legal Entity
//     exercising permissions granted by this License.

//     "Source" form shall mean the preferred form for making modifications,
//     including but not limited to software source code, documentation
//     source, and configuration files.

//     "Object" form shall mean any form resulting from mechanical
//     transformation or translation of a Source form, including but
//     not limited to compiled object code, generated documentation,
//     and conversions to other media types.

//     "Work" shall mean the work of authorship, whether in Source or
//     Object form, made available under the License, as indicated by a
//     copyright notice that is included in or attached to the work
//     (an example is provided in the Appendix below).

//     "Derivative Works" shall mean any work, whether in Source or Object
//     form, that is based on (or derived from) the Work and for which the
//     editorial revisions, annotations, elaborations, or other modifications
//     represent, as a whole, an original work of authorship. For the purposes
//     of this License, Derivative Works shall not include works that remain
//     separable from, or merely link (or bind by name) to the interfaces of,
//     the Work and Derivative Works thereof.

//     "Contribution" shall mean any work of authorship, including
//     the original version of the Work and any modifications or additions
//     to that Work or Derivative Works thereof, that is intentionally
//     submitted to Licensor for inclusion in the Work by the copyright owner
//     or by an individual or Legal Entity authorized to submit on behalf of
//     the copyright owner. For the purposes of this definition, "submitted"
//     means any form of electronic, verbal, or written communication sent
//     to the Licensor or its representatives, including but not limited to
//     communication on electronic mailing lists, source code control systems,
//     and issue tracking systems that are managed by, or on behalf of, the
//     Licensor for the purpose of discussing and improving the Work, but
//     excluding communication that is conspicuously marked or otherwise
//     designated in writing by the copyright owner as "Not a Contribution."

//     "Contributor" shall mean Licensor and any individual or Legal Entity
//     on behalf of whom a Contribution has been received by Licensor and
//     subsequently incorporated within the Work.

//  2. Grant of Copyright License. Subject to the terms and conditions of
//     this License, each Contributor hereby grants to You a perpetual,
//     worldwide, non-exclusive, no-charge, royalty-free, irrevocable
//     copyright license to reproduce, prepare Derivative Works of,
//     publicly display, publicly perform, sublicense, and distribute the
//     Work and such Derivative Works in Source or Object form.

//  3. Grant of Patent License. Subject to the terms and conditions of
//     this License, each Contributor hereby grants to You a perpetual,
//     worldwide, non-exclusive, no-charge, royalty-free, irrevocable
//     (except as stated in this section) patent license to make, have made,
//     use, offer to sell, sell, import, and otherwise transfer the Work,
//     where such license applies only to those patent claims licensable
//     by such Contributor that are necessarily infringed by their
//     Contribution(s) alone or by combination of their Contribution(s)
//     with the Work to which such Contribution(s) was submitted. If You
//     institute patent litigation against any entity (including a
//     cross-claim or counterclaim in a lawsuit) alleging that the Work
//     or a Contribution incorporated within the Work constitutes direct
//     or contributory patent infringement, then any patent licenses
//     granted to You under this License for that Work shall terminate
//     as of the date such litigation is filed.

//  4. Redistribution. You may reproduce and distribute copies of the
//     Work or Derivative Works thereof in any medium, with or without
//     modifications, and in Source or Object form, provided that You
//     meet the following conditions:

//     (a) You must give any other recipients of the Work or
//         Derivative Works a copy of this License; and

//     (b) You must cause any modified files to carry prominent notices
//         stating that You changed the files; and

//     (c) You must retain, in the Source form of any Derivative Works
//         that You distribute, all copyright, patent, trademark, and
//         attribution notices from the Source form of the Work,
//         excluding those notices that do not pertain to any part of
//         the Derivative Works; and

//     (d) If the Work includes a "NOTICE" text file as part of its
//         distribution, then any Derivative Works that You distribute must
//         include a readable copy of the attribution notices contained
//         within such NOTICE file, excluding those notices that do not
//         pertain to any part of the Derivative Works, in at least one
//         of the following places: within a NOTICE text file distributed
//         as part of the Derivative Works; within the Source form or
//         documentation, if provided along with the Derivative Works; or,
//         within a display generated by the Derivative Works, if and
//         wherever such third-party notices normally appear. The contents
//         of the NOTICE file are for informational purposes only and
//         do not modify the License. You may add Your own attribution
//         notices within Derivative Works that You distribute, alongside
//         or as an addendum to the NOTICE text from the Work, provided
//         that such additional attribution notices cannot be construed
//         as modifying the License.

//     You may add Your own copyright statement to Your modifications and
//     may provide additional or different license terms and conditions
//     for use, reproduction, or distribution of Your modifications, or
//     for any such Derivative Works as a whole, provided Your use,
//     reproduction, and distribution of the Work otherwise complies with
//     the conditions stated in this License.

//  5. Submission of Contributions. Unless You explicitly state otherwise,
//     any Contribution intentionally submitted for inclusion in the Work
//     by You to the Licensor shall be under the terms and conditions of
//     this License, without any additional terms or conditions.
//     Notwithstanding the above, nothing herein shall supersede or modify
//     the terms of any separate license agreement you may have executed
//     with Licensor regarding such Contributions.

//  6. Trademarks. This License does not grant permission to use the trade
//     names, trademarks, service marks, or product names of the Licensor,
//     except as required for reasonable and customary use in describing the
//     origin of the Work and reproducing the content of the NOTICE file.

//  7. Disclaimer of Warranty. Unless required by applicable law or
//     agreed to in writing, Licensor provides the Work (and each
//     Contributor provides its Contributions) on an "AS IS" BASIS,
//     WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or
//     implied, including, without limitation, any warranties or conditions
//     of TITLE, NON-INFRINGEMENT, MERCHANTABILITY, or FITNESS FOR A
//     PARTICULAR PURPOSE. You are solely responsible for determining the
//     appropriateness of using or redistributing the Work and assume any
//     risks associated with Your exercise of permissions under this License.

//  8. Limitation of Liability. In no event and under no legal theory,
//     whether in tort (including negligence), contract, or otherwise,
//     unless required by applicable law (such as deliberate and grossly
//     negligent acts) or agreed to in writing, shall any Contributor be
//     liable to You for damages, including any direct, indirect, special,
//     incidental, or consequential damages of any character arising as a
//     result of this License or out of the use or inability to use the
//     Work (including but not limited to damages for loss of goodwill,
//     work stoppage, computer failure or malfunction, or any and all
//     other commercial damages or losses), even if such Contributor
//     has been advised of the possibility of such damages.

//  9. Accepting Warranty or Additional Liability. While redistributing
//     the Work or Derivative Works thereof, You may choose to offer,
//     and charge a fee for, acceptance of support, warranty, indemnity,
//     or other liability obligations and/or rights consistent with this
//     License. However, in accepting such obligations, You may act only
//     on Your own behalf and on Your sole responsibility, not on behalf
//     of any other Contributor, and only if You agree to indemnify,
//     defend, and hold each Contributor harmless for any liability
//     incurred by, or claims asserted against, such Contributor by reason
//     of your accepting any such warranty or additional liability.

//  END OF TERMS AND CONDITIONS

//  APPENDIX: How to apply the Apache License to your work.

//     To apply the Apache License to your work, attach the following
//     boilerplate notice, with the fields enclosed by brackets "[]"
//     replaced with your own identifying information. (Don't include
//     the brackets!)  The text should be enclosed in the appropriate
//     comment syntax for the file format. We also recommend that a
//     file or class name and description of purpose be included on the
//     same "printed page" as the copyright notice for easier
//     identification within third-party archives.

//  Copyright [yyyy] [name of copyright owner]

//  Licensed under the Apache License, Version 2.0 (the "License");
//  you may not use this file except in compliance with the License.
//  You may obtain a copy of the License at

//      http://www.apache.org/licenses/LICENSE-2.0

//  Unless required by applicable law or agreed to in writing, software
//  distributed under the License is distributed on an "AS IS" BASIS,
//  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//  See the License for the specific language governing permissions and
//  limitations under the License.

import {
  type Assume,
  type Column,
  type DrizzleTypeError,
  type Equal,
  getTableColumns,
  is,
  type Simplify,
  type Table,
  type ColumnDataType,
} from "drizzle-orm";
import {
  MySqlChar,
  MySqlVarBinary,
  MySqlVarChar,
} from "drizzle-orm/mysql-core";
import { z, type ZodErrorMap } from "zod";

import { getTitleFormattedString } from "@cloudifybiz/lighthouse-core/utils/format";

const literalSchema = z.union([z.string(), z.number(), z.boolean(), z.null()]);
type Literal = z.infer<typeof literalSchema>;
export type Json = Literal | { [key: string]: Json } | Json[];
export const jsonSchema: z.ZodType<Json> = z.lazy(() =>
  z.union([literalSchema, z.array(jsonSchema), z.record(jsonSchema)]),
);

type MapInsertColumnToZod<
  TColumn extends Column,
  TType extends z.ZodTypeAny,
> = TColumn["_"]["notNull"] extends false
  ? z.ZodOptional<z.ZodNullable<TType>>
  : TColumn["_"]["hasDefault"] extends true
  ? z.ZodOptional<TType>
  : TType;

type MapSelectColumnToZod<
  TColumn extends Column,
  TType extends z.ZodTypeAny,
> = TColumn["_"]["notNull"] extends false ? z.ZodNullable<TType> : TType;

type MapColumnToZod<
  TColumn extends Column,
  TType extends z.ZodTypeAny,
  TMode extends "insert" | "select",
> = TMode extends "insert"
  ? MapInsertColumnToZod<TColumn, TType>
  : MapSelectColumnToZod<TColumn, TType>;

type MaybeOptional<
  TColumn extends Column,
  TType extends z.ZodTypeAny,
  TMode extends "insert" | "select",
  TNoOptional extends boolean,
> = TNoOptional extends true ? TType : MapColumnToZod<TColumn, TType, TMode>;

type GetZodType<TColumn extends Column> =
  TColumn["_"]["dataType"] extends infer TDataType
    ? TDataType extends "custom"
      ? z.ZodAny
      : TDataType extends "json"
      ? z.ZodType<Json>
      : TColumn extends { enumValues: [string, ...string[]] }
      ? Equal<TColumn["enumValues"], [string, ...string[]]> extends true
        ? z.ZodString
        : z.ZodEnum<TColumn["enumValues"]>
      : TDataType extends "array"
      ? z.ZodArray<
          GetZodType<Assume<TColumn["_"], { baseColumn: Column }>["baseColumn"]>
        >
      : TDataType extends "bigint"
      ? z.ZodBigInt
      : TDataType extends "number"
      ? z.ZodNumber
      : TDataType extends "string"
      ? z.ZodString
      : TDataType extends "boolean"
      ? z.ZodBoolean
      : TDataType extends "date"
      ? z.ZodDate
      : z.ZodAny
    : never;

type ValueOrUpdater<T, TUpdaterArg> = T | ((arg: TUpdaterArg) => T);

type UnwrapValueOrUpdater<T> = T extends ValueOrUpdater<infer U, any>
  ? U
  : never;

export type Refine<TTable extends Table, TMode extends "select" | "insert"> = {
  [K in keyof TTable["_"]["columns"]]?: ValueOrUpdater<
    z.ZodTypeAny,
    TMode extends "select"
      ? BuildSelectSchema<TTable, object, true>
      : BuildInsertSchema<TTable, object, true>
  >;
};

export type BuildInsertSchema<
  TTable extends Table,
  TRefine extends Refine<TTable, "insert"> | object,
  TNoOptional extends boolean = false,
> = TTable["_"]["columns"] extends infer TColumns extends Record<
  string,
  Column<any>
>
  ? {
      [K in keyof TColumns & string]: MaybeOptional<
        TColumns[K],
        K extends keyof TRefine
          ? Assume<UnwrapValueOrUpdater<TRefine[K]>, z.ZodTypeAny>
          : GetZodType<TColumns[K]>,
        "insert",
        TNoOptional
      >;
    }
  : never;

export type BuildSelectSchema<
  TTable extends Table,
  TRefine extends Refine<TTable, "select">,
  TNoOptional extends boolean = false,
> = Simplify<{
  [K in keyof TTable["_"]["columns"]]: MaybeOptional<
    TTable["_"]["columns"][K],
    K extends keyof TRefine
      ? Assume<UnwrapValueOrUpdater<TRefine[K]>, z.ZodTypeAny>
      : GetZodType<TTable["_"]["columns"][K]>,
    "select",
    TNoOptional
  >;
}>;

export type Params = {
  errorMap?: ZodErrorMap | undefined;
  invalid_type_error?: string | undefined;
  required_error?: string | undefined;
  description?: string | undefined;
};

export function createInsertSchema<
  TTable extends Table,
  TRefine extends Refine<TTable, "insert"> = Refine<TTable, "insert">,
>(
  table: TTable,
  /**
   * @param refine Refine schema fields
   */
  refine?: {
    [K in keyof TRefine]: K extends keyof TTable["_"]["columns"]
      ? TRefine[K]
      : DrizzleTypeError<`Column '${K &
          string}' does not exist in table '${TTable["_"]["name"]}'`>;
  },
  typeParamsMap?: {
    [K in keyof TRefine]: Params;
  },
  maxLengthMessageMap?: {
    [K in keyof TRefine]: string;
  },
): z.ZodObject<
  BuildInsertSchema<
    TTable,
    Equal<TRefine, Refine<TTable, "insert">> extends true ? object : TRefine
  >
> {
  const columns = getTableColumns(table);
  const columnEntries = Object.entries(columns);

  let schemaEntries = Object.fromEntries(
    columnEntries.map(([name, column]) => {
      return [
        name,
        mapColumnToSchema(
          column,
          typeParamsMap?.[name],
          maxLengthMessageMap?.[name],
        ),
      ];
    }),
  );

  if (refine) {
    schemaEntries = Object.assign(
      schemaEntries,
      Object.fromEntries(
        Object.entries(refine).map(([name, refineColumn]) => {
          return [
            name,
            typeof refineColumn === "function"
              ? refineColumn(
                  schemaEntries as BuildInsertSchema<TTable, object, true>,
                )
              : refineColumn,
          ];
        }),
      ),
    );
  }

  for (const [name, column] of columnEntries) {
    if (!column.notNull) {
      schemaEntries[name] = schemaEntries[name]!.nullable().optional();
    } else if (column.hasDefault) {
      schemaEntries[name] = schemaEntries[name]!.optional();
    }
  }

  return z.object(schemaEntries) as any;
}

export function createSelectSchema<
  TTable extends Table,
  TRefine extends Refine<TTable, "select"> = Refine<TTable, "select">,
>(
  table: TTable,
  /**
   * @param refine Refine schema fields
   */
  refine?: {
    [K in keyof TRefine]: K extends keyof TTable["_"]["columns"]
      ? TRefine[K]
      : DrizzleTypeError<`Column '${K &
          string}' does not exist in table '${TTable["_"]["name"]}'`>;
  },
  typeParamsMap?: {
    [K in keyof TRefine]: Params;
  },
  maxLengthMessageMap?: {
    [K in keyof TRefine]: string;
  },
): z.ZodObject<
  BuildSelectSchema<
    TTable,
    Equal<TRefine, Refine<TTable, "select">> extends true ? object : TRefine
  >
> {
  const columns = getTableColumns(table);
  const columnEntries = Object.entries(columns);

  let schemaEntries = Object.fromEntries(
    columnEntries.map(([name, column]) => {
      return [
        name,
        mapColumnToSchema(
          column,
          typeParamsMap?.[name],
          maxLengthMessageMap?.[name],
        ),
      ];
    }),
  );

  if (refine) {
    schemaEntries = Object.assign(
      schemaEntries,
      Object.fromEntries(
        Object.entries(refine).map(([name, refineColumn]) => {
          return [
            name,
            typeof refineColumn === "function"
              ? refineColumn(
                  schemaEntries as BuildSelectSchema<TTable, object, true>,
                )
              : refineColumn,
          ];
        }),
      ),
    );
  }

  for (const [name, column] of columnEntries) {
    if (!column.notNull) {
      schemaEntries[name] = schemaEntries[name]!.nullable();
    }
  }

  return z.object(schemaEntries) as any;
}

function isWithEnum(
  column: Column,
): column is typeof column & { enumValues: [string, ...string[]] } {
  return (
    "enumValues" in column &&
    Array.isArray(column.enumValues) &&
    column.enumValues.length > 0
  );
}

function getZodTypeParams(
  name: string,
  dataType: ColumnDataType,
  typeParams?: Params,
): Params {
  return {
    ...typeParams,
    invalid_type_error:
      typeParams?.invalid_type_error ?? `${name} must be a ${dataType}`,
    required_error: typeParams?.required_error ?? `${name} is required`,
  };
}

function mapColumnToSchema(
  column: Column,
  typeParams?: Params,
  maxMessage?: string,
): z.ZodTypeAny {
  let type: z.ZodTypeAny | undefined;

  if (isWithEnum(column)) {
    type = column.enumValues.length ? z.enum(column.enumValues) : z.string();
  }

  if (!type) {
    const formattedName = getTitleFormattedString(column.name);
    const zodTypeParams = getZodTypeParams(
      formattedName,
      column.dataType,
      typeParams,
    );
    if (column.dataType === "custom") {
      type = z.any();
    } else if (column.dataType === "json") {
      type = jsonSchema;
    } else if (column.dataType === "number") {
      type = z.number(zodTypeParams);
    } else if (column.dataType === "bigint") {
      type = z.bigint(zodTypeParams);
    } else if (column.dataType === "boolean") {
      type = z.boolean(zodTypeParams);
    } else if (column.dataType === "date") {
      type = z.date(zodTypeParams);
    } else if (column.dataType === "string") {
      let sType = z.string(zodTypeParams);

      if (
        (is(column, MySqlVarChar) ||
          is(column, MySqlVarBinary) ||
          is(column, MySqlChar)) &&
        typeof column.length === "number"
      ) {
        sType = sType.max(
          column.length,
          maxMessage ??
            `${formattedName} can't be longer than ${column.length} characters`,
        );
      }

      type = sType;
    }
  }

  if (!type) {
    type = z.any();
  }

  return type;
}
